/* istanbul ignore file */
import SelectInput from './SelectInput';

export default SelectInput;
